import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, InfoOutlineIcon, Inscription, OptionKey } from '@common-fe/common-fe';

import { DeductibleUser } from './hooks/useDependents';
import SpendTrackerUsersList from './SpendTrackerUsersList';

interface Props {
  coverageLevelLabel?: string;
  users: DeductibleUser[];
  selectedHealthPlanYearId?: OptionKey;
  individualTotal?: number;
  userId?: string;
}

const EmbeddedOnlySpendTracker: React.FC<Props> = ({
  coverageLevelLabel,
  users,
  selectedHealthPlanYearId,
  individualTotal,
  userId,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      direction="column"
      elevation="default"
      round="container1Round"
      fill
      background="canvas"
      style={{ height: 'auto' }}
      pad="spacing24"
    >
      <Inscription weight="bold" margin={{ bottom: 'spacing10' }}>
        {`Coverage level: ${coverageLevelLabel || ''}`}
      </Inscription>
      <Box
        data-testId="embedded-only-info-banner"
        direction="row"
        align="center"
        gap="spacing8"
        background="infoContainer"
        border={{ color: 'infoBorder' }}
        round="container2Round"
        pad={{ horizontal: 'spacing16', vertical: 'spacing8' }}
        width={{ max: 'fit-content' }}
      >
        <InfoOutlineIcon color="info" size="24px" />
        <Inscription>
          {t(
            "Family deductibles aren't supported by your plan. Select a family member to check their individual deductibles"
          )}
        </Inscription>
      </Box>
      <SpendTrackerUsersList
        users={users}
        disabled={!individualTotal}
        selectedHealthPlanYearId={selectedHealthPlanYearId}
        userId={userId}
      />
    </Box>
  );
};

export default EmbeddedOnlySpendTracker;
